import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Calm skeleton — ocean-tinted shimmer driven by Tailwind's
 * built-in ``animate-pulse``. Avoid the loud silver-screen shimmer
 * styles common in marketing dashboards.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-ocean-100",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
